<template>
  <CCard class="products-table">
    <CCardHeader>
      <CIcon name="cil-https" /> Productos
      <div class="card-header-actions">
        <CButton v-if="providersOptions.length > 2" :color="filters ? 'dark' : 'warning'" size="sm"
          @click="toggleFilters" class="filter-btn-compact">
          <CIcon name="cil-filter" />
        </CButton>
        <CButton color="info" size="sm" @click="storeModal()" v-if="canWrite">Nuevo
          Producto</CButton>
      </div>
    </CCardHeader>
    <CCardBody>
      <CRow v-if="filters">
        <CCol md="3"></CCol>
        <CCol md="3"></CCol>
        <CCol md="3"></CCol>
        <CCol md="3">
          <div v-if="providersOptions.length > 2" role="group" class="form-group compact-filter-group">
            <label> Proveedor:</label>
            <CSelect :value.sync="providerSelected" :options="providersOptions" @change="changeFilters" />
          </div>
        </CCol>
      </CRow>
      <CDataTable hover striped border small fixed :items="items"
        :fields="fields" :items-per-page="50" pagination :tableFilter="tableFilter" class="compact-table">
        <template #code="{ item }">
          <td class="text-center w150 p-0 compact-cell">{{ item.code ? item.code : '-' }}</td>
        </template>
        <template #provider_name="{ item }">
          <td class="text-center w200 p-0 compact-cell">{{ item.provider_name ? item.provider_name : 'NO DEFINIDO' }}</td>
        </template>
        <template #brand_name="{ item }">
          <td class="text-center w200 p-0 compact-cell">{{ item.brand_name ? item.brand_name : 'NO DEFINIDA' }}</td>
        </template>
        <template #name="{ item }">
          <td class="text-left p-0 compact-cell compact-left-cell">{{ item.name }}</td>
        </template>
        <template #actions="{ item }">
          <td class="table_actions p-0 compact-cell" v-if="canWrite">
            <CButton color="warning" size="sm" @click="updateModal(item)">
              <CIcon name="cil-pencil" />
            </CButton>
            <CButton color="danger" size="sm" @click="deleteModal(item)">
              <CIcon name="cil-trash" />
            </CButton>
          </td>
          <td class="text-center w50 p-0 compact-cell" v-else>-</td>
        </template>
      </CDataTable>
    </CCardBody>
    <ProductModal ref="productModal" @store="storeProcess" @update="updateProcess"></ProductModal>
    <DeleteModal ref="deleteModal" @delete="deleteProcess"></DeleteModal>
  </CCard>
</template>

<script>
import ProductModal from './ProductModal.vue'
import DeleteModal from '../global/DeleteModal.vue'
import ws from '../../services/products';
import providers_ws from '../../services/providers';
import store from '../../store'

export default {
  name: 'ProductsTable',
  components: { ProductModal, DeleteModal },
  props: {
    items: Array,
    permissions: Array | Object,
  },
  data() {
    return {
      filters: false,
      fields: [
        { key: 'code', label: 'Código' },
        { key: 'provider_name', label: 'Proveedor' },
        { key: 'brand_name', label: 'Marca' },
        { key: 'name', label: 'Nombre' },
        { key: 'actions', label: 'Acciones', class: 'actions' },
      ],
      providers: [],
      providersOptions: [],
      providerSelected: "",
      lastAppliedProvider: null,
      tableFilter: {
        label: 'Buscar: ',
        placeholder: '...'
      },
    }
  },
  mounted: async function () {
    await this.loadProviders();
  },
  computed: {
    canWrite () {
      return this.permissions && this.permissions['products.write'] === true
    }
  },
  methods: {
    async loadProviders () {
      let response = await providers_ws.get();

      if (response.type == "success") {
        this.providers = response.data;
        this.providersOptions = await this.$parseSelectOptionsOrdered(this.providers, "id", "name", [{ value: '0', label: 'Todos los Proveedores' }]);
      } else {
        this.showToast(response.type || 'error', response.message || 'No fue posible cargar proveedores');
      }
    },
    toggleFilters() {
      this.filters = !this.filters;
    },
    async changeFilters(force = false) {
      const currentProvider = this.providerSelected || "";
      if (!force && this.lastAppliedProvider === currentProvider) {
        return;
      }

      this.loading();

      let filters = this.getFilters();
      let response = await ws.getFiltered(filters);

      if (response.type == "success") {
        this.$emit("refresh", response.data);
        this.lastAppliedProvider = currentProvider;
      }

      this.loaded();
    },
    async refreshTable () {
      await this.changeFilters(true);
    },
    getFilters() {
      let filters = {
        provider: this.providerSelected
      };

      return filters;
    },
    storeModal() {
      this.$refs.productModal.storeModal(this.providerSelected);
    },
    updateModal(item) {
      this.$refs.productModal.updateModal(item);
    },
    deleteModal(item) {
      this.$refs.deleteModal.show("Eliminar Producto", item.id, item.name);
    },
    async storeProcess(data) {
      let response = await ws.store(data);

      if (response.type == "success") {
        await this.refreshTable();
      }

      this.showToast(response.type, response.message);
    },
    async updateProcess(data) {
      let response = await ws.update(data);

      if (response.type == "success") {
        await this.refreshTable();
      }

      this.showToast(response.type, response.message);
    },
    async deleteProcess(id) {
      let response = await ws.delete({ id: id });

      if (response.type == "success") {
        await this.refreshTable();
      }

      this.showToast(response.type, response.message);
    },
    showToast(type, message) {
      store.commit('toast', { color: type, message: message });
    },
    loading() {
      store.commit('loading');
    },
    loaded() {
      store.commit('loaded');
    }
  }
}
</script>

<style scoped>
.products-table {
  font-size: 12px;
}

.products-table :deep(.card-header),
.products-table :deep(.card-body),
.products-table :deep(.table),
.products-table :deep(.table th),
.products-table :deep(.table td),
.products-table :deep(.form-control),
.products-table :deep(.btn),
.products-table :deep(label) {
  font-size: 12px;
}

.filter-btn-compact {
  height: 26px;
  padding: 2px 5px;
}

.compact-filter-group {
  margin: -10px 0 10px;
}

.compact-table :deep(.table td),
.compact-table :deep(.table th) {
  padding-top: 3px !important;
  padding-bottom: 3px !important;
}

.compact-cell {
  font-size: 12px;
}

.compact-left-cell {
  padding-left: 5px !important;
}
</style>
